import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConvenioService
{
    constructor(private http: HttpClient) { }

    traeMontoTotalDisponible(idUsuario : any){
        return this.http.get(`${environment.urlApiPrestamo}/totalDisponibleConvenio/${idUsuario}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    calcularPlanPagoConvenio(monto:any, cantidadCuotas:any){
        return this.http.get(`${environment.urlApiPrestamo}/calculaPlanPago/convenio/${monto}/cuotas/${cantidadCuotas}`,
        { headers: this.armaCabecera() }).toPromise();
    }
    traeCategoriaConvenio(){
        return this.http.get(`${environment.urlApiPrestamo}/getTipoConvenio`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeProveedorSelect(){
        return this.http.get(`${environment.urlApiPrestamo}/getProveedores`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeRegiones()
    {      
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeRegionesEspeciales()
    {
        return this.http.get(`${environment.urlApiUsuario}/regionesConvenios`, { headers: this.armaCabecera() } ).toPromise()
    }


    traeProveedoresPorRegionyTipo(region:any, cat:any){
        return this.http.get(`${environment.urlApiPrestamo}/proveedor/${region}/segun/${cat}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeConvenioColaboracionPorRegion(region:any){
        return this.http.get(`${environment.urlApiPrestamo}/convenioColaboracion/region/${region}`,
        { headers:this.armaCabecera() }).toPromise();
    } 

    
    enviarConvenioColaboracion(convenioId: any,usuarioId: any,idAfiliado: any, cargaId:any, idRegion:any){
 
        return this.http.post(`${environment.urlApiPrestamo}/convenioColaboracion/enviar`,
        {
            convenioColaboracionId:convenioId,
            idUsuario: usuarioId,
            idCarga:cargaId,
            idAfiliado:idAfiliado,
            idRegion:  idRegion          
        },
        { headers: this.armaCabecera() }).toPromise();
        
    }

    traeCantidadCuotasProveedor(proveedor: any){
        return this.http.get(`${environment.urlApiPrestamo}/cuotasProveedor/${proveedor}`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeCapacidadDescuento(idUsuario: any){
        return this.http.get(`${environment.urlApiPrestamo}/capacidadDescuentoConvenio/${idUsuario}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeCantidadCuotas(){
       
        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotas`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeEstados()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }
    
    ingresarConvenio(usuarioId: any,idAfiliado: any,
        convenio: any,beneficiario:any,codeudor:any, codeudor2:any, planes:any){
     console.log("beneficiario ",beneficiario);
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/convenio`,
        {
            idUsuario: idAfiliado,
            idCarga:beneficiario,
            idProducto: 5,
            archivoAdjunto:  convenio.archivo,
            convenio:  {montoSolicitado: convenio.montoSolicitado,
                 idUsuario:usuarioId,
                 idAfiliado:idAfiliado,
                 idCodeudorUno:codeudor.idCodeudor,
                 idCodeudorDos:codeudor2.idCodeudor,
                 totalCuota:planes[0].montoTotalCuota,
                 fechaPrimerPago:planes[0].fechaPago, 
                 idCantidadCuota:convenio.idCantidadCuota,
                 idTipoConvenio: convenio.idTipoConvenio,
                 montoCuota: planes[0].montoCuota
                 ,    planes: planes ,
                 numPresupuesto:convenio.numPresupuesto,
                 idProveedor:convenio.idProveedor,
                 idRegion:convenio.idRegion ,
                 idCarga:beneficiario
            }
             
            
          //  notificacion: { email:escolaridad.email, nombreCompleto:nombreUsuario, nombreProducto: 'PRESTAMO' }

        },
        { headers: this.armaCabecera() }).toPromise();
        
    }


    sumarReembolso(usuario: any,esTitular : any,categoria:any){
      
        return this.http.get(`${environment.urlBase}/usuario/${usuario}/titular/${esTitular}/reembolsos/subcategoria/${categoria}/idPostulacion/0`
        ,{ headers:this.armaCabecera() }).toPromise();
    }

    sinPostulacionesVigentes(idProducto: any, rut: any, titular: any)
    {
        return this.http.get(`${environment.urlBase}/postulaciones/productos/${idProducto}/rut/${rut}/titular/${titular}`,
               { headers: this.armaCabecera() } ).toPromise();
    }
   
    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rutEstados/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
    
    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    cambiarEstadoPostulacion(idPostulacion: any, estado: any)
    {
      
        return this.http.post(`${environment.urlApiPrestamo}/solicitudes/`,
               { id: idPostulacion, estado: estado }, { headers:this.armaCabecera() } ).toPromise();
    }

    rechazarPostulacion(idPostulacion: any, idMotivoRechazo: any, motivoRechazo: any, comentarioRechazo: any)
    {
        return  this.http.post(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            estado: 'RECHAZADA',
            idMotivoRechazo: idMotivoRechazo,
            comentarioMotRechazo: comentarioRechazo,
            motivo: motivoRechazo
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionesDisponibles(email: any, buscador?: any)

    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivo/email`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estado
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionesAsignadas(idEjecutivo: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivos/id`,
        {
            id:idEjecutivo,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            rut: buscador?.rut,
            estado: buscador?.estado
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
        console.log(postulaciones)
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }

   

    editaPostulacionBeca(idPostulacion: any, idCarga: any, nota: any, idCurso: any,idUsuario:any)
    {
        return this.http.put(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            idCarga: idCarga,
            idUsuario: idUsuario,
            idProducto: 1,
            beca: { calificacion:nota, idCurso:idCurso }
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    

    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiPrestamo}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traeArchivos(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traeArchivosConvenio(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiPrestamo}/postulaciones/${idPostulacion}/archivo-adjunto-convenio/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    

    rechazarSerCodeudor(convenio:any, idCodeudor: any,resultado:any){
        console.log("rechazo ser codeudor!!!!!!!!",convenio)
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/rechazar/convenio`,
        {   idPostulacion:convenio.idPostulacion,
            idPrestamo:convenio.idPrestamo,
            idCodeudor:idCodeudor,
            convenio:{ idPostulacion:convenio.idPostulacion,
                        idConvenio:convenio.idConvenio,
                        idUsuario: idCodeudor}
        }
        ,{ headers:this.armaCabecera() }).toPromise();
    }

    aprobarSerCodeudor(convenio:any, idCodeudor: any,resultado:any){
        console.log("convenio!!!! aprobar ser codeudor",convenio);
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/aprobar/convenio`,
        {      idPostulacion:convenio.idPostulacion,
            idConvenio:convenio.idConvenio,
            idCodeudor:idCodeudor,
            convenio:{ idPostulacion:convenio.idPostulacion,
                        idConvenio:convenio.idConvenio,
                        idUsuario: idCodeudor},
            //archivoAdjunto: [ { url: "", archivo: archivo.archivo, extension:archivo.extension }
            archivoAdjunto: convenio.archivos
        }
        ,{ headers:this.armaCabecera() }).toPromise();

    }
 
    guardarEdicion(convenio:any,idUsuario:any,numPresupuesto:any){
       
        return this.http.post(`${environment.urlApiPrestamo}/convenio/guardar`,
        {
            
            idCarga:0,
            idProducto: 5,
            idEjecutivo:idUsuario,
            idPostulacion: convenio.idPostulacion,
            convenio:  {
                montoSolicitado: convenio.montoSolicitado,
                idCantidadCuota:convenio.idCantidadCuota,
                tipoPrestamo:convenio.tipoPrestamo,
                montoCuota:convenio.montoCuota,
                idConvenio:convenio.idConvenio,
                fechaPrimerPago:convenio.fechaPrimerPago,
                idPostulacion: convenio.idPostulacion,
                idRegion:convenio.idRegion  ,
                idProveedor:convenio.idProveedor,
                idTipoConvenio:convenio.idTipoConvenio,
                idAfiliado:convenio.idAfiliado,
                numPresupuesto: numPresupuesto,
               // montoCuota: convenio.planes[0].montoCuota,
                planes: convenio.planes
                 }
                 
           
          //  notificacion: { email:escolaridad.email, nombreCompleto:nombreUsuario, nombreProducto: 'PRESTAMO' }

        },

        { headers: this.armaCabecera() }).toPromise();
    }
    anularReversarConvenio(idPostulacion:any,asientoContable:any,idUsuario:any){
        return this.http.post(`${environment.urlApiPrestamo}/reversar/convenio/`,
        {
            idPostulacion: idPostulacion,
            asientoContable: asientoContable},
        { headers:this.armaCabecera() }).toPromise()
    }
    traeProveedoresPorId(idProveedor){
        return this.http.get(`${environment.urlApiPrestamo}/proveedor/${idProveedor}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
